import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { audit } from 'rxjs/operators';
import { AuditService } from '../../../../shared/services/audit.service';
import { EnquiryChecklistService } from '../../../../shared/services/enquiry-checklist.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-enquiries-audit-form',
  templateUrl: './enquiries-audit-form.component.html',
  styleUrls: ['./enquiries-audit-form.component.scss']
})
export class EnquiriesAuditFormComponent implements OnInit {


  @Input() formName: string = '';
  @Input() caseId: number;
  @Input() itemId: number;

  auditFormItems: MatTableDataSource<any>[] = [];

  displayedColumns: string[] = ['enquiry', 'fieldName', 'oldValue', 'newValue', 'byUser', 'dateChanged'];


  constructor(
    public activeModal: NgbActiveModal,
    private auditService: AuditService,
    private enquiryService: EnquiryChecklistService  ) {

  }

  ngOnInit(): void {

      if (this.caseId != null && this.caseId > 0) {
      this.auditService.getAuditItemsForCaseForm(this.formName, this.caseId).subscribe((response: any) => {

        this.mapEnquiryData(response);

      });
    }
   
  }

  private mapEnquiryData(auditData: any[]) {
    this.enquiryService.getEnquiryChecklistForCase(this.caseId)
      .subscribe(data => {
        auditData.forEach(function (item, idx) {
          var enquiry = data.find(x => x.id == item.itemId);
          if (enquiry != null) {
            item.enquiry = enquiry.enquiry;
          }
        });

        this.auditFormItems = auditData.sort((a, b) => {
          return (a.itemId > b.itemId) ? 1 : -1;
        });

      });
  }

}
